module.exports = `${require.publicPath}bg03.04d6e98e.png`;